// Assumptions (table-row variants for the full-page assumptions table — distinct
// from the card-based intake/ components above)
export { AssumptionModeToggle as AssumptionTableModeToggle } from "./assumptions/AssumptionModeToggle";
export type {
  AssumptionRolloutPeriod,
  AssumptionRolloutScheduleProps,
} from "./assumptions/AssumptionRolloutSchedule";
export { AssumptionRolloutSchedule } from "./assumptions/AssumptionRolloutSchedule";
export type {
  AssumptionCadenceBucket,
  AssumptionMetricGroup,
  AssumptionSummaryRowsTableProps,
  AssumptionTableRow,
} from "./assumptions/AssumptionSummaryRowsTable";
export {
  AssumptionSummaryRowsTable,
  AssumptionTableLayout,
} from "./assumptions/AssumptionSummaryRowsTable";
export type {
  AssumptionSummaryAnnualColumn,
  AssumptionSummaryCell,
  AssumptionSummaryGroup,
  AssumptionSummaryGroupKind,
  AssumptionSummaryRampDisplay,
  AssumptionSummaryRow,
  AssumptionSummaryTableProps,
  AssumptionSummaryValueState,
} from "./assumptions/AssumptionSummaryTable";
export { AssumptionSummaryTable } from "./assumptions/AssumptionSummaryTable";
export { AssumptionValueField as AssumptionTableValueField } from "./assumptions/AssumptionValueField";
// Data Display — Org Profile Components
export type { ImpactChipProps, ImpactChipRef } from "./data-display/ImpactChip";
export { ImpactChip } from "./data-display/ImpactChip";
export type { MixEntry, MixSectionProps } from "./data-display/MixSection";
export { MixSection } from "./data-display/MixSection";
export type { OrgDataRowProps } from "./data-display/OrgDataRow";
export { OrgDataRow } from "./data-display/OrgDataRow";
export type { OrgIssuesBannerProps } from "./data-display/OrgIssuesBanner";
export { OrgIssuesBanner } from "./data-display/OrgIssuesBanner";
export type {
  BaselineRowProps,
  EncounterRowProps,
  FoundationalRowProps,
  IdentityRowProps,
} from "./data-display/OrgRows";
export {
  BaselineRow,
  EncounterRow,
  FoundationalRow,
  IdentityRow,
} from "./data-display/OrgRows";
export type { OrgSectionCardProps } from "./data-display/OrgSectionCard";
export { OrgSectionCard } from "./data-display/OrgSectionCard";
export type { ProfileCompletionRingProps } from "./data-display/ProfileCompletionRing";
export { ProfileCompletionRing } from "./data-display/ProfileCompletionRing";
export type { RoleRowProps } from "./data-display/RoleRow";
export { RoleRow } from "./data-display/RoleRow";
export type { SubRowProps } from "./data-display/SubRow";
export { SubRow } from "./data-display/SubRow";
export type { TechRowProps } from "./data-display/TechRow";
export { TechRow } from "./data-display/TechRow";
// Explorer — workflow map
export type {
  BreadcrumbMenuCrumb,
  BreadcrumbMenuProps,
  BreadcrumbSibling,
  CarouselProps,
  CoverageBarProps,
  CoverageCounts,
  CoverageMeterProps,
  CoverageRingProps,
  CoverageState,
  CoverageSummaryBarProps,
  FunctionCardProps,
  FunctionTileApplication,
  FunctionTileProps,
  FunctionTileWorkflow,
  HoverPopoverProps,
  MapLinkComponent,
  RelatedLink,
  RelatedLinksProps,
  SearchDialogGroup,
  SearchDialogProps,
  SearchDialogResult,
  SearchDialogState,
  SearchKind,
  SearchTriggerProps,
  StepCardApplication,
  StepCardProduct,
  StepCardProps,
  StepCardStep,
  StepSegment,
  StepSegmentApplication,
  StepSegmentBarProps,
  WorkflowCardProps,
} from "./explorer";
export {
  BreadcrumbMenu,
  Carousel,
  COVERAGE_LABEL,
  COVERAGE_STATES,
  CoverageBar,
  CoverageLegend,
  CoverageMeter,
  CoverageRing,
  CoverageSummaryBar,
  CoverageSwatch,
  coverageTotal,
  FunctionCard,
  FunctionTile,
  HoverPopover,
  isApplePlatform,
  isSearchShortcut,
  RelatedLinks,
  SearchDialog,
  SearchTrigger,
  StepCard,
  StepSegmentBar,
  useSearchShortcut,
  WorkflowCard,
} from "./explorer";
// Explorer
export type {
  ProportionBarProps,
  ProportionLegendProps,
  ProportionSegment,
} from "./explorer/ProportionBar";
export { ProportionBar, ProportionLegend } from "./explorer/ProportionBar";
export type { StatFigureProps } from "./explorer/StatFigure";
export { StatFigure } from "./explorer/StatFigure";
export type { SummaryCardProps } from "./explorer/SummaryCard";
export { SummaryCard } from "./explorer/SummaryCard";
export type {
  FormulaViewerButtonProps,
  FormulaViewerProps,
  FormulaViewerToken,
} from "./formula/FormulaViewer";
export { FormulaViewer, FormulaViewerButton } from "./formula/FormulaViewer";
// Intake
export type { BackTileProps } from "./intake/BackTile";
export { BackTile } from "./intake/BackTile";
export type { ConfirmGoBackModalProps } from "./intake/ConfirmGoBackModal";
export { ConfirmGoBackModal } from "./intake/ConfirmGoBackModal";
export type { IntakeFooterBarProps } from "./intake/IntakeFooterBar";
export { IntakeFooterBar } from "./intake/IntakeFooterBar";
export type {
  LoadingEstimate,
  LoadingSequenceProps,
} from "./intake/LoadingSequence";
export { LoadingSequence } from "./intake/LoadingSequence";
export type {
  MetricReviewCardProps,
  MetricReviewStatus,
} from "./intake/MetricReviewCard";
export { MetricReviewCard } from "./intake/MetricReviewCard";
export type {
  MetricReviewQueueItem,
  MetricReviewQueueItemStatus,
  MetricReviewQueueProps,
} from "./intake/MetricReviewQueue";
export { MetricReviewQueue } from "./intake/MetricReviewQueue";
export type { MetricRevisionControlsProps } from "./intake/MetricRevisionControls";
export { MetricRevisionControls } from "./intake/MetricRevisionControls";
export type { MetricsPickerProps } from "./intake/MetricsPicker";
export { MetricsPicker } from "./intake/MetricsPicker";
export type {
  OrganizationBreadcrumbProps,
  OrganizationMissingDataBannerProps,
  OrganizationOverviewHeroProps,
  OrganizationProgressDonutProps,
  OrganizationSaveBarProps,
  OrganizationSectionCardData,
  OrganizationSectionMeta,
  OrganizationSectionNavCardProps,
  OrganizationSectionStatusIconProps,
  TechnologyStackListProps,
} from "./organization";
export {
  OrganizationBreadcrumb,
  OrganizationLoadingSkeleton,
  OrganizationMissingDataBanner,
  OrganizationOverviewHero,
  OrganizationProgressDonut,
  OrganizationSaveBar,
  OrganizationSectionIcon,
  OrganizationSectionNavCard,
  OrganizationSectionStatusIcon,
  TECHNOLOGY_CATEGORY_LABELS,
  TECHNOLOGY_CATEGORY_ORDER,
  TechnologyStackList,
} from "./organization";

// Data Display

export type {
  AssumptionDetailHistory,
  AssumptionDetailHistorySeed,
  AssumptionDetailRailProps,
  AssumptionDetailRow,
} from "./assumptions/AssumptionDetailRail";
export { AssumptionDetailRail } from "./assumptions/AssumptionDetailRail";
export type { AssumptionEditPopoverProps } from "./assumptions/AssumptionEditPopover";
export { AssumptionEditPopover } from "./assumptions/AssumptionEditPopover";
export type {
  AssumptionHistoryDialogProps,
  AssumptionHistoryEntry,
} from "./assumptions/AssumptionHistoryDialog";
export { AssumptionHistoryDialog } from "./assumptions/AssumptionHistoryDialog";
export type {
  AssumptionMetricLink,
  AssumptionRow,
  AssumptionsTableProps,
} from "./assumptions/AssumptionsTable";
export { AssumptionsTable } from "./assumptions/AssumptionsTable";
export {
  currencyUnitSuffix,
  formatAssumptionNum,
  isCurrency,
  isPercentLike,
} from "./assumptions/formatAssumptionNum";
export type {
  MetricModelabilityCardMetric,
  MetricModelabilityCardProps,
  MetricModelabilityIssue,
  MetricModelingStatus,
} from "./assumptions/MetricModelabilityCard";
export { MetricModelabilityCard } from "./assumptions/MetricModelabilityCard";
export type { OrganizationValueConfirmModalProps } from "./assumptions/OrganizationValueConfirmModal";
export { OrganizationValueConfirmModal } from "./assumptions/OrganizationValueConfirmModal";
/* ---- Phase 6: Assumptions Components ---- */
export type { PendingChangesBarProps } from "./assumptions/PendingChangesBar";
export { PendingChangesBar } from "./assumptions/PendingChangesBar";
export type { RoiBandProps } from "./assumptions/RoiBand";
export { RoiBand } from "./assumptions/RoiBand";
export type {
  UnmodelledMetricListItem,
  ValueStream,
  ValueStreamListItem,
  ValueStreamListStream,
  ValueStreamsListProps,
} from "./assumptions/ValueStreamsList";
export { ValueStreamsList } from "./assumptions/ValueStreamsList";
// Legacy (existing Turborepo stubs)
export { Button } from "./button";
export { Card } from "./card";
export { InvestmentCurveChart } from "./charts/InvestmentCurveChart";
export { PortfolioChart } from "./charts/PortfolioChart";
// Charts
export { SensitivityTornado } from "./charts/SensitivityTornado";
export { ValueStreamWaterfall } from "./charts/ValueStreamWaterfall";
export { Code } from "./code";
export type { ApprovalCircleProps } from "./data-display/ApprovalCircle";
export { ApprovalCircle } from "./data-display/ApprovalCircle";
// --- Intake: Shared Atomic Components (Phase 2) ---
export type { CitationChipProps } from "./data-display/CitationChip";
export { CitationChip } from "./data-display/CitationChip";
export { ConfidenceBadge } from "./data-display/ConfidenceBadge";
export { DeltaBadge } from "./data-display/DeltaBadge";
export type { ExecSummaryProps } from "./data-display/ExecSummary";
export { ExecSummary } from "./data-display/ExecSummary";
export { HeroStats } from "./data-display/HeroStats";
export type { InfoDotProps } from "./data-display/InfoDot";
export { InfoDot } from "./data-display/InfoDot";
export type { InfoTipProps } from "./data-display/InfoTip";
export { InfoTip } from "./data-display/InfoTip";
export type { MarkdownProseProps } from "./data-display/MarkdownProse";
export { MarkdownProse } from "./data-display/MarkdownProse";
export type {
  NarrativeBlockData,
  NarrativeBlockProps,
} from "./data-display/NarrativeBlock";
export { NarrativeBlock } from "./data-display/NarrativeBlock";
export type { OrgStatePreviewerProps } from "./data-display/OrgStatePreviewer";
export { OrgStatePreviewer } from "./data-display/OrgStatePreviewer";
export { PhaseSummaryCard } from "./data-display/PhaseSummaryCard";
export type { ProvenanceDotProps } from "./data-display/ProvenanceDot";
export { ProvenanceDot } from "./data-display/ProvenanceDot";
export type {
  Provenance,
  ProvenancePillProps,
} from "./data-display/ProvenancePill";
export { ProvenancePill } from "./data-display/ProvenancePill";
export type {
  FormulaTokenConfig,
  FormulaTokenTarget,
  ReportMetricItem,
  ReportValueStreamsProps,
} from "./data-display/ReportValueStreams";
export { ReportValueStreams } from "./data-display/ReportValueStreams";
export type { ReviseSectionProps } from "./data-display/ReviseSection";
export { ReviseSection } from "./data-display/ReviseSection";
export type { RolloutScheduleProps } from "./data-display/RolloutSchedule";
export { RolloutSchedule } from "./data-display/RolloutSchedule";
export { SourceBadge } from "./data-display/SourceBadge";
export type { SourceChipProps } from "./data-display/SourceChip";
export { SourceChip } from "./data-display/SourceChip";
export type { SrcCardProps, SrcCardSource } from "./data-display/SrcCard";
export { SrcCard } from "./data-display/SrcCard";
export {
  type FeedbackSubmission,
  FeedbackWidget,
} from "./feedback/FeedbackWidget";
// Forms
export type {
  EditableAutocompleteProps,
  EditableBooleanProps,
  EditableSelectProps,
  EditableValueProps,
  SelectOption,
} from "./forms/EditableValue";
export {
  EditableAutocomplete,
  EditableBoolean,
  EditableSelect,
  EditableValue,
} from "./forms/EditableValue";
export { NumericInput } from "./forms/NumericInput";
export type { OrgFieldEditModalProps } from "./forms/OrgFieldEditModal";
export { OrgFieldEditModal } from "./forms/OrgFieldEditModal";
export { ScenarioToggle } from "./forms/ScenarioToggle";
export type {
  Vendor,
  VendorPickerModalProps,
  VendorRecord,
} from "./forms/VendorPickerModal";
export { VendorPickerModal } from "./forms/VendorPickerModal";
export type {
  SliderEntry,
  WeightedSliderEditorProps,
} from "./forms/WeightedSliderEditor";
export { WeightedSliderEditor } from "./forms/WeightedSliderEditor";
export type {
  FormulaExpressionInput,
  FormulaExpressionProps,
  FormulaExpressionToken,
  FormulaTokenKind,
} from "./formula/FormulaExpression";
export {
  FormulaExpression,
  tokenizeFormula,
} from "./formula/FormulaExpression";
export type { AiBubbleProps } from "./intake/AiBubble";
export { AiBubble } from "./intake/AiBubble";
export type { AvatarProps } from "./intake/Avatar";
export { Avatar } from "./intake/Avatar";
// --- Intake: Chat Atoms (Phase 3) ---
export type { AvatarStackProps } from "./intake/AvatarStack";
export {
  AvatarStack,
  avatarColorClass,
  avatarInitials,
} from "./intake/AvatarStack";
export type { ChatComposerProps } from "./intake/ChatComposer";
export { ChatComposer } from "./intake/ChatComposer";
export type {
  ChatSrcChip,
  ChatSrcChipsProps,
} from "./intake/ChatSrcChips";
export { ChatSrcChips } from "./intake/ChatSrcChips";
export type { CitationData, CiteDetailProps } from "./intake/CiteDetail";
export { CiteDetail } from "./intake/CiteDetail";
export type {
  CiteHistoryProps,
  HistoryStage,
} from "./intake/CiteHistory";
export { CiteHistory } from "./intake/CiteHistory";
export type {
  ConfirmValue,
  ConfirmValuesProps,
} from "./intake/ConfirmValues";
export { ConfirmValues } from "./intake/ConfirmValues";
/* ---- Phase 5: Rail Components ---- */
export type { EmptyStateProps } from "./intake/EmptyState";
export { EmptyState } from "./intake/EmptyState";
export type {
  FillInBlankProps,
  FillInBlankSegment,
} from "./intake/FillInBlank";
export { FillInBlank } from "./intake/FillInBlank";
/* ---------- Opportunity report ----------
 * Eight-section report ported from the Assumptions/Report MVP design project.
 * See docs/frontend/intake-report-port-plan.md. */
export type { FormulaTraceModalProps } from "./intake/FormulaTraceModal";
export { FormulaTraceModal } from "./intake/FormulaTraceModal";
export type { FunnelProps, FunnelStep } from "./intake/Funnel";
export { Funnel } from "./intake/Funnel";
export type { HistoryPointRowProps } from "./intake/HistoryPointRow";
export { HistoryPointRow } from "./intake/HistoryPointRow";
export type { HistorySetupCardProps } from "./intake/HistorySetupCard";
export { HistorySetupCard } from "./intake/HistorySetupCard";
export type { HistoryStatLineProps } from "./intake/HistoryStatLine";
export { HistoryStatLine } from "./intake/HistoryStatLine";
export type { HistoryVersionCardProps } from "./intake/HistoryVersionCard";
export { HistoryVersionCard } from "./intake/HistoryVersionCard";
export { MOCK_OPPORTUNITY_HISTORY } from "./intake/history-mock";
export type {
  HistoryPointVM,
  HistorySetupVM,
  HistorySeverity,
  HistoryVersionVM,
  OpportunityHistoryVM,
} from "./intake/history-types";
export { SEVERITY_TOOLTIPS } from "./intake/history-types";
export type {
  InlineAdjustProps,
  InlineAdjustValue,
} from "./intake/InlineAdjust";
export { InlineAdjust } from "./intake/InlineAdjust";
export type {
  ChatHistoryMessage,
  IntakeChatHistoryProps,
} from "./intake/IntakeChatHistory";
export { IntakeChatHistory } from "./intake/IntakeChatHistory";
/* ---- Shared graph-prompt UI ---- */
export type {
  CheckboxListItem,
  IntakeCheckboxListProps,
} from "./intake/IntakeCheckboxList";
export { IntakeCheckboxList } from "./intake/IntakeCheckboxList";
/* ---- Phase 7: Page Components & Orchestrators ---- */
export type { IntakeLayoutProps, IntakeStep } from "./intake/IntakeLayout";
export { IntakeLayout } from "./intake/IntakeLayout";
export type {
  IntakeMeasureProps,
  MeasureMetric,
  MeasureState,
} from "./intake/IntakeMeasure";
export { IntakeMeasure } from "./intake/IntakeMeasure";
export type {
  IntakeMetricSelectProps,
  MetricItem,
} from "./intake/IntakeMetricSelect";
export { IntakeMetricSelect } from "./intake/IntakeMetricSelect";
export type {
  IntakeModelStatusProps,
  ModelSnapshotStatus,
} from "./intake/IntakeModelStatus";
export { IntakeModelStatus } from "./intake/IntakeModelStatus";
export type {
  IntakeOptionCardProps,
  IntakeOptionIndicator,
} from "./intake/IntakeOptionCard";
export { IntakeOptionCard } from "./intake/IntakeOptionCard";
export type {
  IntakeProductPickerProps,
  ProductItem,
} from "./intake/IntakeProductPicker";
export { IntakeProductPicker } from "./intake/IntakeProductPicker";
export type {
  IntakeRadioListProps,
  RadioListItem,
} from "./intake/IntakeRadioList";
export { IntakeRadioList } from "./intake/IntakeRadioList";
export type {
  IntakeRefineRowProps,
  IntakeRefineRowVariant,
} from "./intake/IntakeRefineRow";
export { IntakeRefineRow } from "./intake/IntakeRefineRow";
export type { IntakeSourceBadgeProps } from "./intake/IntakeSourceBadge";
export { IntakeSourceBadge } from "./intake/IntakeSourceBadge";
export type {
  IntegrationItem,
  IntegrationsProps,
} from "./intake/Integrations";
export { Integrations } from "./intake/Integrations";
export type {
  MarketplaceLookupProduct,
  MarketplaceProductLookupProps,
} from "./intake/MarketplaceProductLookup";
export { MarketplaceProductLookup } from "./intake/MarketplaceProductLookup";
export type {
  MetricDefinitionReviewItem,
  MetricDefinitionReviewProps,
} from "./intake/MetricDefinitionReview";
export { MetricDefinitionReview } from "./intake/MetricDefinitionReview";
export type { OpportunityHistoryProps } from "./intake/OpportunityHistory";
export { OpportunityHistory } from "./intake/OpportunityHistory";
export type { ProductFitCheckingProps } from "./intake/ProductFitChecking";
export { ProductFitChecking } from "./intake/ProductFitChecking";
export type { ProductFitWarningProps } from "./intake/ProductFitWarning";
export { ProductFitWarning } from "./intake/ProductFitWarning";
export type {
  ProductGridProduct,
  ProductGridProps,
} from "./intake/ProductGrid";
export { ProductGrid } from "./intake/ProductGrid";
export type {
  ProductSearchProduct,
  ProductSearchProps,
} from "./intake/ProductSearch";
export { ProductSearch } from "./intake/ProductSearch";
export type { PromptHeaderProps } from "./intake/PromptHeader";
export { PromptHeader } from "./intake/PromptHeader";
export type { ProductIdentity } from "./intake/product-identity";
export {
  formatProductIdentity,
  ProductIdentityLine,
  ProductVendorLabel,
} from "./intake/product-identity";
export type { RailHomeProps } from "./intake/RailHome";
export { RailHome } from "./intake/RailHome";
export type { ReportCitationMarkerProps } from "./intake/ReportCitationMarker";
export { ReportCitationMarker } from "./intake/ReportCitationMarker";
export type { ReportComparableVendorsProps } from "./intake/ReportComparableVendors";
export { ReportComparableVendors } from "./intake/ReportComparableVendors";
export type { ReportExecSummaryProps } from "./intake/ReportExecSummary";
export { ReportExecSummary } from "./intake/ReportExecSummary";
export type { ReportFiguresListProps } from "./intake/ReportFiguresList";
export { ReportFiguresList } from "./intake/ReportFiguresList";
export type { ReportHeaderBadgesProps } from "./intake/ReportHeaderBadges";
export {
  ReportHeaderBadges,
  scopeTileSentence,
} from "./intake/ReportHeaderBadges";
export type { ReportKeyRisksProps } from "./intake/ReportKeyRisks";
export { ReportKeyRisks } from "./intake/ReportKeyRisks";
export type { ReportMetricsListProps } from "./intake/ReportMetricsList";
export { ReportMetricsList } from "./intake/ReportMetricsList";
export type { ReportOverviewProps } from "./intake/ReportOverview";
export { ReportOverview } from "./intake/ReportOverview";
export type { ReportPendingNoticeProps } from "./intake/ReportPendingNotice";
export { ReportPendingNotice } from "./intake/ReportPendingNotice";
export type { ReportSectionHeadingProps } from "./intake/ReportSectionHeading";
export { ReportSectionHeading } from "./intake/ReportSectionHeading";
export type { ReportSectionPlaceholderProps } from "./intake/ReportSectionPlaceholder";
export { ReportSectionPlaceholder } from "./intake/ReportSectionPlaceholder";
export type {
  ReportShellProps,
  ReportShellSectionProps,
} from "./intake/ReportShell";
export { ReportShell, ReportShellSection } from "./intake/ReportShell";
export type {
  ReportSourceFlashTarget,
  ReportSourcesProps,
} from "./intake/ReportSources";
export { ReportSources } from "./intake/ReportSources";
export type {
  ReportTileGridProps,
  ReportTileProps,
} from "./intake/ReportTile";
export { ReportTile, ReportTileGrid } from "./intake/ReportTile";
export type { ReportVendorRationaleProps } from "./intake/ReportVendorRationale";
export { ReportVendorRationale } from "./intake/ReportVendorRationale";
export type {
  ReportSummary,
  ReportSummaryProduct,
  ReportViewProps,
} from "./intake/ReportView";
export { ReportView } from "./intake/ReportView";
export type { BuildReportFiguresInput } from "./intake/report-figures";
export {
  buildReportFigureRows,
  buildReportFigures,
} from "./intake/report-figures";
export {
  computedReportFixture,
  partialReportFixture,
  pendingReportFixture,
} from "./intake/report-fixtures";
export {
  formatHorizonYears,
  formatReportUsd,
  REPORT_EMPTY_VALUE,
} from "./intake/report-format";
export type {
  ReportProseAssertion,
  ReportProseSegment,
  ReportValueRef,
  ResolvedProseSegment,
} from "./intake/report-prose";
export {
  resolveReportProse,
  validateProseAssertions,
} from "./intake/report-prose";
export type {
  OpenAssumptionHandler,
  OpenAssumptionsHandler,
  ReportAttribution,
  ReportClaim,
  ReportComparableVendor,
  ReportData,
  ReportExecSummaryBullet,
  ReportFigureKey,
  ReportFigureRow,
  ReportFigures,
  ReportMetricRow,
  ReportMetricShift,
  ReportProblem,
  ReportRationaleRow,
  ReportScope,
  ReportScopeOrigin,
  ReportScopeTile,
  ReportSectionId,
  ReportSectionMeta,
  ReportSource,
  ReportStreamRow,
  ReportTraceAggregate,
  ReportTraceContributor,
  ReportTraceHistoryEntry,
  ReportTraceKnownInput,
  ReportTraceNode,
  ReportTraceNodeKind,
  ReportTraceTarget,
} from "./intake/report-types";
export { REPORT_SECTIONS } from "./intake/report-types";
export type {
  SourceListCitation,
  SourceListProps,
} from "./intake/SourceList";
export { SourceList } from "./intake/SourceList";
export type {
  StaleModalCardProps,
  StaleModalValue,
} from "./intake/StaleModalCard";
export { StaleModalCard } from "./intake/StaleModalCard";
export type { SuggestedReplyProps } from "./intake/SuggestedReply";
export { SuggestedReply } from "./intake/SuggestedReply";
// --- Intake: Smart Components (Phase 4) ---
export type {
  TwoOptionSelectOption,
  TwoOptionSelectProps,
} from "./intake/TwoOptionSelect";
export { TwoOptionSelect } from "./intake/TwoOptionSelect";
export type {
  StaleValue,
  UpdatesPanelProps,
} from "./intake/UpdatesPanel";
export { UpdatesPanel } from "./intake/UpdatesPanel";
export type { UserBubbleProps } from "./intake/UserBubble";
export { UserBubble } from "./intake/UserBubble";
// Layout
export {
  ErrorBoundary,
  SectionErrorBoundary,
  withErrorBoundary,
} from "./layout/ErrorBoundary";
export type { LoaderProps } from "./layout/Loader";
export { Loader } from "./layout/Loader";
// Utilities
export { formatCompact, formatCurrency, formatMoneyShort } from "./lib/format";
export {
  editDistance,
  fuzzyScore,
  isSubsequence,
  tokenFuzzy,
} from "./lib/fuzzy-search";
// --- Intake: Shared Utilities (Phase 1) ---
export type { IconName, IconProps } from "./lib/icons";
export {
  Alert as IcAlert,
  ArrowL as IcArrowL,
  ArrowR as IcArrowR,
  ArrowUpR as IcArrowUpR,
  Book as IcBook,
  Bulb as IcBulb,
  Check as IcCheck,
  ChevD as IcChevD,
  ChevR as IcChevR,
  Clock as IcClock,
  Compass as IcCompass,
  Doc as IcDoc,
  ElionE as IcElionE,
  FileText as IcFileText,
  Globe as IcGlobe,
  Grid as IcGrid,
  Ic,
  Info as IcInfo,
  LongArr as IcLongArr,
  Pen as IcPen,
  Plus as IcPlus,
  Search as IcSearch,
  User as IcUser,
  X as IcX,
} from "./lib/icons";
export type {
  CitationLike,
  DerivationKind,
  ProvenanceType,
  ProvMeta,
} from "./lib/provenance";
export {
  DERIV_CLS,
  DERIV_INFO,
  DERIV_LABEL,
  derivationOf,
  effType,
  PROV_META,
  TYPE_INFO,
} from "./lib/provenance";
export {
  formatDateLabel,
  formatRelativeTime,
  formatTimeLabel,
} from "./lib/time-format";
// Navigation
export type {
  ChangeItem,
  ChangesModalProps,
  NavItem,
  NavProduct,
  NavTheme,
  OppChangeRecord,
  OppChangesModalProps,
  OrgIssueCounts,
  OrgItem,
  OrgSaveBarProps,
  OrgSaveBarValidity,
  OrgSwitcherModalProps,
  OrgTopBarProps,
  ProfileMenuProps,
  SectionState,
  SideNavProps,
  Theme,
} from "./navigation";
export {
  ChangesModal,
  OppChangesModal,
  OrgSaveBar,
  OrgStatusIndicator,
  OrgSwitcherModal,
  OrgTopBar,
  ProfileMenu,
  SideNav,
} from "./navigation";
export type { SlideOverProps } from "./overlays/SlideOver";
export { SlideOver } from "./overlays/SlideOver";
